// File type constants for consistent file handling across the application

// Document file extensions
export const DOCUMENT_EXTENSIONS = ['.pptx', '.docx', '.pdf', '.txt', '.xlsx', '.xls', '.csv'];

// Document MIME types
export const DOCUMENT_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
  'text/plain',
  'application/vnd.google-apps.document',
  'application/vnd.google-apps.presentation',
  'application/vnd.google-apps.spreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv'
];

// Audio/Video file extensions
export const AUDIO_VIDEO_EXTENSIONS = ['.mp3', '.aac', '.m4a', '.mp4', '.mkv', '.wav', '.ogg', '.mov', '.avi'];

// Audio/Video MIME types
export const AUDIO_VIDEO_MIME_TYPES = [
  'audio/mpeg',
  'audio/aac',
  'audio/x-m4a',
  'audio/mp4',
  'video/mp4',
  'video/x-matroska',
  'audio/wav',
  'audio/ogg',
  'video/quicktime',
  'video/x-msvideo',
  'audio/vnd.wave'
];

// Helper function to convert extensions array to acceptTypes string for input elements
export function getDocumentAcceptTypes() {
  return DOCUMENT_EXTENSIONS.join(',');
}

export function getAudioVideoAcceptTypes() {
  return AUDIO_VIDEO_EXTENSIONS.join(',');
}

// Helper function to get file extension from filename
export function getFileExtension(filename) {
  if (!filename || typeof filename !== 'string') return '';
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
}

// Check if file is a document type
export function isDocumentFile(fileName, mimeType) {
  if (mimeType && DOCUMENT_MIME_TYPES.includes(mimeType.toLowerCase())) {
    return true;
  }
  const extension = getFileExtension(fileName);
  return extension && DOCUMENT_EXTENSIONS.includes(`.${extension}`);
}

// Check if file is an audio/video type
export function isAudioVideoFile(fileName, mimeType) {
  if (mimeType && AUDIO_VIDEO_MIME_TYPES.includes(mimeType.toLowerCase())) {
    return true;
  }
  const extension = getFileExtension(fileName);
  return extension && AUDIO_VIDEO_EXTENSIONS.includes(`.${extension}`);
}